export enum AuditionPhase {
  SUBMISSION = 'Submission',
  SELF_TAPES = 'Self Tapes',
  SELF_TAPES_REQUEST = 'Self Tapes Request',
  SELF_TAPES_PROCESS = 'Self Tapes Process',
  DECISION = 'Decision',
  DECISION_AVAIL = 'Decision Avail',
  DECISION_BOOKED = 'Decision Booked',
}
